'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 18 28',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'g',
                { fill: props.fill, fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', { d: 'M6.143 7.809L8.99 3.09l2.759 4.718z' }),
                _react2.default.createElement('path', { d: 'M4.096 7.809L1.783 4.452l7.296 3.357z' }),
                _react2.default.createElement('path', { d: 'M13.884 7.809l2.224-3.357-7.296 3.357zM15.93 11.62c1.068 1.996 1.157 3.81.801 5.444-.8 2.268-3.47 6.714-4.538 7.803a3.494 3.494 0 0 1-2.58 1.089H8.634c-.623 0-1.69-.182-2.58-1.09-1.068-1.088-3.737-5.534-4.538-7.802-.623-1.724-.534-3.448.534-5.444 1.157-2.087 2.046-2.813 2.046-2.813h9.788s.89.726 2.046 2.813zm-8.72 5.625c0-.454-.533-.816-.533-.816s-.534.362-.534.816c0 .454.534.817.534.817s.534-.363.534-.817zm4.539 0c0-.454-.534-.816-.534-.816s-.534.362-.534.816c0 .454.534.817.534.817s.534-.363.534-.817zm-2.225 3.72c0-.453-.534-.816-.534-.816s-.534.363-.534.816c0 .454.534.817.534.817s.534-.363.534-.817zm-4.627-7.53c0-.454-.534-.817-.534-.817s-.534.363-.534.816c0 .454.534.817.534.817s.534-.363.534-.817zm4.627 0c0-.454-.534-.817-.534-.817s-.534.363-.534.816c0 .454.534.817.534.817s.534-.363.534-.817zm4.538 0c0-.454-.534-.817-.534-.817s-.534.363-.534.816c0 .454.534.817.534.817s.534-.363.534-.817z' })
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#FFF',
    width: '18px',
    height: '28px'
};

Icon.displayName = 'ProductBonusPlusWhite';

exports.default = Icon;